import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl"
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';

import { Modal, Button } from "react-bootstrap";
import * as Icon from 'react-bootstrap-icons';
import { synclab } from '../authservice/authservice';

function Settingspage() {
    const Swal = require('sweetalert2')
const sync = localStorage.getItem("sync");
    const accesstoken = localStorage.getItem("token");
    const [nablchechk, setnablchechk] = useState("0");
    const [isSubscribed, setIsSubscribed] = useState(false);
    const[value,setvalue]=useState("");
    
    
    const handlenabl = (event) => {
        var checked = event.target.checked;

        if (checked == true) {
            setnablchechk("1");

        }
        else {
            setnablchechk("0");
   
        }
        setIsSubscribed(!isSubscribed)
     
    };

    useEffect(()=>{

const getsync=()=>{

    axios
    .get(baseurladdress + `getsync`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(res => {
        const datas = res.data.response;
        console.log("itemss" + datas[0].ddchrsettings_labsync);
 

console.log("items" + value);
        const checkpublish = (datas[0].ddchrsettings_labsync == "1") ? true : false;
        console.log("item" + checkpublish);
        setIsSubscribed(checkpublish);
        console.log(isSubscribed);
    })
    .catch(error => {
        alert(error);
    })   
}
getsync();
    },[])

    const handleSubmit = (event) => {
        synclab(nablchechk) ; 

        event.preventDefault();
        var data = {
            ddchrsettings_labsync: nablchechk,

        };
        axios
        .post(baseurladdress + `synclab`,data ,{
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
        .then(res => {
           
const data=res.data.status;
const dataa=res.data.message

console.log(data);

if (data === "updated") {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1800,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    Toast.fire({
        icon: 'success',
        title: dataa
    })
    // alert(dataa);
   

  }
        })
    }



    return (

        <div className="content-wrap">
            <div className="main">
                <div className="container-fluid">

                    {/* /# row */}
                    <section id="main-content">

                    
                       
                           
                              
                                            <div className="col-lg-3">
                                            <div class="card">
                            <div class="card-header">
                                <h4 class="card-title">Synchronization</h4>
                            </div>
                            <div class="card-body">
                                <div class="basic-form">
                                    <form>
                                        <div class="form-group" style={{"text-align":"center"}}>
                                            <div class="form-check mb-3 button">
                                                
                                            <input type="checkbox" class="form-check-input" id="check1" checked={isSubscribed}  onClick={ handlenabl} />
                                            <label class="form-check-label" for="check1" style={{"text-align":"left"}} >Do you want to synchronize app with DDCLABS software?</label>
                                            <br></br>
                                          
                                            <button
        type="button"
        class="d-grid gap-2 d-md-flex justify-content-md-end"
        className="btn btn-primary"
        onClick={handleSubmit}
    
    >
        Apply changes
    </button> 
                                               
                                            </div>

                                           
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                                            </div>
                                    
                       


                        {/* /# column */}

                    </section>
                </div>
            </div>
        </div>

    )

}

export default Settingspage;